import { render, staticRenderFns } from "./EditTeamDialog.vue?vue&type=template&id=d2c4c9ac"
import script from "./EditTeamDialog.vue?vue&type=script&lang=js"
export * from "./EditTeamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports